export default {
  setGoodRemains(state, payload) {
    state.goodRemains = payload
  },
  updateGoodRemains(state, payload) {
    state.goodRemains = state.goodRemains.concat(payload)
  },
  setGoodRemainFilters(state, payload) {
    state.goodRemainFilters = payload
  },
  setGoodRemain(state, payload) {
    state.goodRemain = payload
  },
  setGoodRemainHistory(state, payload) {
    state.goodRemainHistory = payload
  },
  removeGoodRemain(state, id) {
    for (let i = 0; i < state.goodRemains.length; i++) {
      if (state.goodRemains[i].id === id) {
        state.goodRemains.splice(i, 1)
        break
      }
    }
  },
}
